import Vue from 'vue'
import Router from 'vue-router'
//应用中心路由配置
import myManager from './myManager'
//其他
import other from './other'

Vue.use(Router);

export default new Router({
  routes: [
    {path: '/login', meta: {title: '登录'},component: resolve => { require(['../pages/components/login/login.vue'], resolve) }},
    {path: '/resetPassword', meta: {title: '找回密码'},component: resolve => { require(['@/pages/components/login/ResetPassword.vue'], resolve) }},
    {path: '/', meta: {title: '首页'},component: resolve => { require(['../pages/index.vue'], resolve) },
      children: [
        {path: 'general', meta: {title: '首页-工作台'},component: resolve => { require(['../pages/components/home/General.vue'], resolve) }},
        {path: 'home', meta: {title: '首页-应用中心'},component: resolve => { require(['../pages/Home.vue'], resolve) }},
        ...myManager
      ]
    },
    //其他
    ...other,
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js